'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _slicedToArray = require('@babel/runtime-corejs3/helpers/slicedToArray');
var rxjs = require('rxjs');
var operators = require('rxjs/operators');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);

/**
 * Retry an observable a configurable number of times with exponential backoff.
 *
 * @export
 * @template T
 * @param {number} maxTries The retry times.
 * @param {number} ms Initial backoff timeout.
 * @param {Subject<any>} destroyed Signal to stop retrying.
 * @returns {MonoTypeOperatorFunction<T>}
 */
function backoff(maxTries, ms, destroyed) {
  return operators.retryWhen(function (attempts) {
    return rxjs.zip(attempts, rxjs.range(1, maxTries + 1)).pipe(operators.takeUntil(destroyed), operators.mergeMap(function (_ref) {
      var _ref2 = _slicedToArray__default["default"](_ref, 2),
        error = _ref2[0],
        i = _ref2[1];
      if (i > maxTries) {
        return rxjs.throwError(error);
      }
      return rxjs.timer(i * i * ms);
    }));
  });
}

exports.backoff = backoff;
